import React, { Suspense, lazy } from 'react';

import type { RichTextEditorProps } from './RichTextEditor.props';

export * from './RichTextEditor.props';

// Lazy-load the Quill-backed implementation so quill + react-quilljs don't
// ship in any chunk that hasn't yet mounted the editor. Consumers keep
// importing `{ RichTextEditor }` from this path — the wrapper is transparent.
const LazyRichTextEditorImpl = lazy(() =>
  import('./RichTextEditor').then((m) => ({ default: m.RichTextEditor }))
);

export const RichTextEditor: React.FC<RichTextEditorProps> = (props) => (
  <Suspense fallback={null}>
    <LazyRichTextEditorImpl {...props} />
  </Suspense>
);
